import React from 'react';
import numeral from 'numeral';
import qs from 'qs';
import Encoding from 'encoding-japanese';

import { floatFormat, integerFormat, numberFormat, integerChangeFormat, } from './shared/util';

export function readFile(file, type = 'readAsText') {
  const reader = new FileReader();
  reader[type](file);
  return new Promise((resolve) => {
    reader.addEventListener('load', _ => resolve(_.target.result));
  });
};

export function fullPathWithParams(params, { pathname, search }) {
  const currentParams = qs.parse(decodeURI(search.slice(1)));
  const newParams = {
    ...currentParams,
    ...params
  };
  const newSearch = qs.stringify(newParams);
  return `${pathname}${newSearch ? `?${newSearch}` : ''}`;
};

export function yen(value) {
  return (
    <>
      <span className="mr-1">&yen;</span>
      <span>{integerFormat(value)}</span>
    </>
  );
}

export function formFloatFormat(value) {
  return numeral(value).format('0,0[.][000000]');
}

export function dateStringToDate(dateString) {
  const [y, m, d] = (dateString.split(/[/-]/) || []).map(_ => Number(_));
  return new Date(y, m - 1, d);
};

export function encode (text, encoding = 'UTF8_BOM') {
  if (encoding === 'UTF8_BOM') {
    return new Blob(['\uFEFF', text], { type: 'text/csv;charset=utf-8;' });
  }
  const code = Encoding.stringToCode(text);
  return new Uint8Array(Encoding.convert(code, encoding, 'UNICODE'));
};

export { floatFormat, integerFormat, numberFormat, integerChangeFormat, };
